module.exports = __webpack_public_path__ + "img/google-play.0a5a93c.webp?v=1764823240413";